import * as React from 'react';
import Select from 'react-select';
import { isNull, isArray, isObject, isString } from 'lodash';
import { HelpBlock } from 'react-bootstrap';
import { OptionComponent, valueComponent } from '../../helpers/SessionCam';
import FaInfoCircle = require('react-icons/lib/fa/info-circle');

export const parseValue = (input) => {
  if (isNull(input)) {
    return '';
  }

  if (isArray(input) && isObject(input[0])) {
    return input.map((item) => item.value);
  }

  return isString(input) || isArray(input) ? input : input.value;
};

export default ({
  input = {},
  options = [{label: '', value: ''}],
  placeholder = '',
  disabled = false,
  className = '',
  meta = {},
  ...props}) => {
  const onBlur = () => input.onBlur(parseValue(input.value));
  const onChange = (value) => input.onChange(parseValue(value));

  return (
    <div className={meta.touched && meta.error ? 'has-error' : ''}>
      <Select
        value={input.value}
        valueComponent={valueComponent}
        className={meta.dirty ? className + ' dirty-field' : className}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        options={options}
        disabled={disabled}
        optionComponent={OptionComponent}
      />
      {meta.touched && meta.error && <HelpBlock><FaInfoCircle />{' '}<strong>{meta.error}</strong></HelpBlock>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/SelectControl/index.tsx